define('shoptheme/components/customer/terms-of-use-agreement',[
    "jquery",
    "cartware/components/_base",
	"cartware/components/Registry",
    "text!shoptheme/templates/magnific-popup/default.html",
    "magnific-popup",
    "cookieconsent3"
], function(
    $,
    Component,
    Registry,
    PopupHtml
) {
    var COOKIE_NAME = 'terms_of_use_accepted';
    var _popupTemplate = null;

    return Component.create({
        agreement: null,
        checkbox: null,
        button: null,

        $init: function() {
            var self = this;
	        Registry().retrieve("featureFlags", function(featureFlags) {
		        if (featureFlags.isEnabled("show_cookie_consent_banner")) {
		            self._init();
                }
	        });
        },

	    _init: function() {
		    var self = this;
		    $(window).load(function() {
			    cookieconsent.hasTransition = false;

			    window.cookieconsent.initialise({
				    container: $('body'),
				    revokable: false,
				    law: {
					    regionalLaw: false
				    },
				    location: false,
				    cookie: {
					    path: cookieconsent_options.path,
					    domain: cookieconsent_options.domain
				    },
				    content: {
					    message: cookieconsent_options.message,
					    dismiss: cookieconsent_options.dismiss,
					    link: null
				    },
				    layout: 'gigaset',
				    layouts: {
					    'gigaset': '<div class="cc_banner-wrapper ">\
                        <div class="cc_banner cc_container cc_container--open">{{compliance}}\
                        {{message}}</div></div>'
				    },
				    compliance: {
					    'info': '<div class="cc_btnz cc_btn_accept_all">{{dismiss}}</div>'
				    },
				    onPopupOpen: function(){
					    self.agreement = $('.terms-of-use-agreement');
					    self.checkbox = $('input[type="checkbox"]', self.agreement);
					    self.button = $('a.cc-btn');

					    if (typeof terms_of_use_agreement_options !== 'undefined'
						    && terms_of_use_agreement_options.is_active
					    ) {
						    if (terms_of_use_agreement_options.is_accepted) {
							    self.unblockPage();
							    self.checkbox.prop('checked', true);
							    self.button.removeClass('hidden');
						    } else {
							    self.blockPage();
							    self.checkbox.prop('checked', false);
							    self.button.addClass('hidden');
						    }
					    }
					    $(window).trigger('cookieconsent.open');
				    },
				    onPopupClose: function(){
					    $(window).trigger('cookieconsent.close');
				    }
			    });


			    $(document).on("click", '.cc_container p a', function (e) {
				    var link = $(e.currentTarget);
				    if (link.hasClass('cc_btn')) {
					    return;
				    }
				    e.preventDefault();
				    link.prop('href', self._updateUrlParameter(link.prop('href'), 'isAjax', 1));

				    link.magnificPopup({
					    type: 'ajax',
					    callbacks: {
						    parseAjax: function (mfpResponse) {
							    var html = mfpResponse.data.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, '');

							    mfpResponse.data = self._renderPopup({
								    body: html
							    });
						    }
					    }
				    }).magnificPopup('open');
			    });

			    $(document).on('click', '.terms-of-use-agreement input[type="checkbox"]', function (e) {
				    if (self.checkbox.prop('checked')) {
					    self.setCookie(COOKIE_NAME, 'yes', 365, cookieconsent_options.path, cookieconsent_options.domain);
					    terms_of_use_agreement_options.is_accepted = true;
					    self.unblockPage();
					    self.button.removeClass('hidden');
				    } else {
					    self.setCookie(COOKIE_NAME, null, -1, cookieconsent_options.path, cookieconsent_options.domain);
					    terms_of_use_agreement_options.is_accepted = false;
					    self.blockPage();
					    self.button.addClass('hidden');
				    }
			    });

		    });
	    },

        blockPage: function() {
            if ($('#page-blocker').length === 0) {
                $("body").append('<div id="page-blocker"></div>');
            }
        },

        unblockPage: function() {
            $('#page-blocker').remove();
        },
        setCookie: function(name, value, expirydays, path, domain) {
            var exdate = new Date();
            expirydays = expirydays || 365;
            exdate.setDate(exdate.getDate() + expirydays);
            document.cookie = name + '=' + value + '; expires=' + exdate.toUTCString() + '; path=' + path + '; domain=' + domain;
        },
        _renderPopup: function(data) {
            if (null === _popupTemplate) {
                _popupTemplate = _.template(PopupHtml);
            }

            return _popupTemplate(data);
        },
        _updateUrlParameter: function(uri, key, value) {
            var i = uri.indexOf('#');
            var hash = i === -1 ? ''  : uri.substr(i);
            uri = i === -1 ? uri : uri.substr(0, i);

            var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";
            if (uri.match(re)) {
                uri = uri.replace(re, '$1' + key + "=" + value + '$2');
            } else {
                uri = uri + separator + key + "=" + value;
            }
            return uri + hash;
        }
    });
});
